import React from 'react';
import { Route, defer } from 'react-router-dom';

import ClientsPage from '@pages/clients/Clients';
import AircraftView from '@pages/inventory/AircraftView';
import Inventory from '@pages/inventory/Inventory';
import Login from '@pages/login/Login';
import Valuation from '@pages/valuation/Valuation';

import Home from '../../pages/home/Home';
import AuthLayout from '../AuthLayout';
import ProtectedRoute from '../routeGuards/ProtectedRoute';
import UnprotectedRoute from '../routeGuards/UnprotectedRoute';
import { RoutingPaths, RoutingViews } from '../services/routingService';

export const AppRoutes = (getUser: () => void): React.ReactNode => (
  <Route element={<AuthLayout />} loader={() => defer({ user: getUser() })}>
    <Route element={<UnprotectedRoute />}>
      <Route path="/" element={<Login />} />
    </Route>

    <Route path="/" element={<ProtectedRoute />}>
      <Route path={RoutingPaths[RoutingViews.HOME]} element={<Home />} />

      <Route
        path={RoutingPaths[RoutingViews.CLIENTS]}
        element={<ClientsPage />}>
        <Route
          path={RoutingPaths[RoutingViews.CLIENTS_VIEW]}
          element={<ClientsPage />}
        />
      </Route>

      <Route
        path={RoutingPaths[RoutingViews.INVENTORY]}
        element={<Inventory />}
      />
      <Route
        path={RoutingPaths[RoutingViews.INVENTORY_AIRCRAFT]}
        element={<AircraftView />}
      />
      <Route
        path={RoutingPaths[RoutingViews.TRANSACTIONS]}
        element={<Valuation />}
      />
    </Route>
  </Route>
);
